import React from 'react';

export default function ConversionComponentInfo(component) {
    return (
        <div className="col-12">
            <div className="alert alert--conversion">
                <p className="font-weight-bold mb-0">{component?.metadata?.title}</p>
                <p className="mb-0">{component?.metadata?.intro}</p>
            </div>
        </div>
    );
}
